module.exports = "/_next/static/images/LeverageFacebookAds@2x-c73d1e070f38b3edfc40878203298e8c.png";